import { seriesLiqui } from "./series"
import { updateDataGrouping, updateBewertungPlotline, zoomIn } from "./helpers"
import { ChartConstants } from "../shared/constants"

export function buildConfig(chartDepot) {
	const data = chartDepot.data

	return {
		chart: {
			events: {
				selection: function (event) {
					return zoomIn(chartDepot, event)
				},
			},
		},

		xAxis: {
			ordinal: false,
			min: data.startdatum,
			max: data.enddatum,
			plotLines: [
				{
					id: "bewertungsplotline",
					color: "#2F3435",
					width: 2,
					dashStyle: "longdashdot",
					zIndex: 10,
					bewertungsdatum: data.bewertungsdatum,
					value: data.bewertungsdatum - 60 * 60 * 24 * (365 - 30.41) * 1000, // Das Chart öffnet immer in der Jahresansicht
					label: {
						text: `Aktuelle Bewertung<br>zum ${moment(new Date(data.bewertungsdatum)).format("MM / YYYY")}`,
						rotation: 0,
						y: 15,
						x: 10,
						textAlign: "left",
						style: {
							color: ChartConstants.fontColorGrau,
							fontSize: ChartConstants.fontSizeMittel,
						},
					},
				},
			],
			events: {
				afterSetExtremes: function (event) {
					const chart = event.target.chart
					const min = event.min
					const max = event.max

					updateDataGrouping(chart, min, max)
					updateBewertungPlotline(chart)
				},
			},
		},

		yAxis: [
			{},
			{
				opposite: true,
			},
		],

		legend: {
			enabled: true,
			events: {
				itemClick: function (event) {
					const item = event?.legendItem
					const seriesId = item?.options?.id
					if (!seriesId) return true

					const willBeVisible = !item.visible
					chartDepot.onLegendToggle?.(seriesId, willBeVisible)
					return true
				},
			},
		},

		plotOptions: {
			series: {
				events: {
					click: function (event) {
						// Prevent the global click@window handler (icon-navigation#closeByClick)
						// from closing the modal right after we open/replace it via Turbo.
						event.preventDefault()

						if (!event.point) return
						chartDepot.openDetailansicht(event.point.x)
					},
				},
				cursor: "pointer",
			},
			area: {
				stacking: "normal",
			},
		},

		series: seriesLiqui(data),
	}
}
